import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
    getIntegralWorksAction,
    updateIntegralWorksListAction
} from "../action/IntergralWorksAction";

export const IntergralWorksReducer = (
    builder: ActionReducerMapBuilder<{
        getIntegralWorksConfig: any;
        updateIntegralWorksListConfig: any;
    }>
) => {
    builder.addCase(getIntegralWorksAction.fulfilled, (state, { payload }) => {
        state.getIntegralWorksConfig = payload;
    });
    builder.addCase(updateIntegralWorksListAction.fulfilled, (state, { payload }) => {
        state.updateIntegralWorksListConfig = payload;
    });
};
